import { atom } from 'jotai';

const openQuickFilterAtom = atom<string | null>(null);

export { openQuickFilterAtom };
